// src/providers/QueryProvider.tsx
import { PropsWithChildren, useState } from "react";
import {
  QueryClient,
  QueryClientProvider,
  QueryCache,
} from "@tanstack/react-query";

/**
 * Tek bir QueryClient oluşturalım ve app genelinde kullanalım.
 * Retry/GC sürelerini üretim için makul değerlere ayarladık.
 */
export function QueryProvider({ children }: PropsWithChildren) {
  const [client] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error, query) => {
            // Sessiz log; istersen burada toasta veya Sentry’ye gönderebilirsin.
            if (import.meta.env.MODE !== "production") {
              // eslint-disable-next-line no-console
              console.warn("[react-query] error:", query?.queryKey, error);
            }
          },
        }),
        defaultOptions: {
          queries: {
            // “okuma” istekleri için varsayılanlar
            staleTime: 30_000, // 30s taze
            gcTime: 5 * 60_000, // 5dk cache
            refetchOnWindowFocus: false,
            retry: (failureCount, error: any) => {
              // 401/403 gibi kimlik hatalarında otomatik retry etme
              const msg = String(error?.message || "");
              if (msg.includes("unauthorized") || msg.includes("forbidden")) return false;
              return failureCount < 2;
            },
          },
          mutations: {
            retry: 0,
          },
        },
      })
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}

export default QueryProvider;
